/**
 *	nearby-shops.conf.js
 */
 
import angular from 'angular';
import nearbyShops from './nearby-shops.directive.js';

export default angular.module('nearbyShops', [])
	.directive('nearbyShops', nearbyShops)
	.name;